import { Directive, forwardRef, Input } from '@angular/core'
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms'

@Directive({
  selector: '[appValidateDNI][ngModel],[appValidateDNI][formControl],[appValidateDNI][formControlName]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => DNIValidator), multi: true }
  ]
})
export class DNIValidator implements Validator {
  validate(control: AbstractControl) {
    if (!control.value) {
      return null
    }

    const stringValue = control.value.toString()

    if ( stringValue.indexOf('.') > -1 || stringValue.indexOf(',') > -1) {
        return {
            dni: { valor: 'invalido' }
        }
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/dni.validator.ts